import React from "react"
import "./Items.css"
import Item from "./Item"

function Items({
  orderData,
  orderProducts,
  customProducts,
  setProductQuantity,
  maxQuantities,
  closeButtonAction
}) {
  const products = orderProducts || []
  return (
    <div className="Items">
      <h1 className="header">Items in Cart</h1>
      {products &&
        products.length > 0 &&
        products.map(product => (
          <Item
            key={product.id}
            product={product}
            currency={orderData.currency}
            max={maxQuantities[product.id]}
            setProductQuantity={setProductQuantity}
            closeButtonAction={closeButtonAction}
            orderUUID={orderData.uuid}
            type="regular"
            shipped={orderData.order_status !== "not shipped"}
          />
        ))}
      {customProducts &&
        customProducts.length > 0 &&
        customProducts.map(product => (
          <Item
            key={product.id}
            product={product}
            currency={orderData.currency}
            max={product.quantity}
            setProductQuantity={setProductQuantity}
            closeButtonAction={closeButtonAction}
            orderUUID={orderData.uuid}
            type="custom"
          />
        ))}
    </div>
  )
}

export default Items
